<template>
  <div class="autoRefundSms">
    <inputForm
      :inputData="inputData"
      :btnPosition1="true"
      ref="form"
      @toParentVal="getSmsData"
    ></inputForm>
    <div class="table">
      <!-- 表格 -->
      <el-table
        :data="tableData"
        v-loading="talbeLoading"
        style="width: 100%; margintop: 20px"
        :header-cell-style="{ background: '#FAFAFA' }"
      >
        <template slot="empty">
          <div>
            <img src="@/assets/images/default/暂无任何数据.png" />
            <span style="margin-left: -140px">暂无任何数据</span>
          </div>
        </template>
        <el-table-column prop="mobile" label="手机号码">
          <template slot-scope="scope">{{ scope.row.mobile || "--" }}</template>
        </el-table-column>
        <el-table-column prop="orderId" label="订单号"></el-table-column>
        <el-table-column
          prop="refundOrderId"
          label="退款申请单号"
        ></el-table-column>
        <el-table-column prop="sendContent" label="短信内容" width="500">
          <template slot="header" slot-scope="scope">
            <span>短信内容</span> &nbsp;
            <span
              class="open"
              v-show="!tableOpenAll"
              @click="tableOpenAll = true"
              >展开全部</span
            >
            <span
              class="stop"
              v-show="tableOpenAll"
              @click="tableOpenAll = false"
              >收起全部</span
            >
          </template>
          <template slot-scope="scope">
            <el-tooltip
              class="tooltip"
              effect="light"
              :content="scope.row.sendContent"
              placement="top"
            >
              <div class="hoveTitle" v-show="!tableOpenAll">
                {{ scope.row.sendContent }}
              </div>
            </el-tooltip>
            <div class="hoveTitleShowMore" v-show="tableOpenAll">
              {{ scope.row.sendContent }}
            </div>
          </template>
        </el-table-column>

        <el-table-column label="发送状态">
          <template slot-scope="scope">
            <p class="state">
              <span
                :class="
                  scope.row.status == 1
                    ? 'blue'
                    : scope.row.status == 2
                    ? 'red'
                    : ''
                "
              ></span>
              {{
                scope.row.status == 1
                  ? "已发送"
                  : scope.row.status == 2
                  ? "未发送"
                  : ""
              }}
            </p>
          </template>
        </el-table-column>

        <el-table-column label="发送时间">
          <template slot-scope="scope">
            <!-- {{ scope.row.sendStartTime }} - {{ scope.row.sendEndTime }} --->
            {{scope.row.sendTime}}
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="current"
        :page-sizes="[10, 30, 50, 100]"
        :page-size="size"
        background
        layout="total, sizes, prev, pager, next, jumper"
        class="pagination"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import inputForm from "@/components/inputForm";
import { querySmsList } from "@/api/serviceCenter/refundWaring";

export default {
  components: {
    inputForm,
  },
  data() {
    return {
      inputData: [
        {
          name: "订单编号:",
          val: "orderId",
          placeholder: "请输入订单编号",
        },
        {
          name: "退款单号:",
          val: "refundNo",
          placeholder: "请输入退款单号",
        },
        {
          name: "发送时间:",
          myDate: true,
          val: ["sendStartTime", "sendEndTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          isdefault:true,
        },
        {
          name: "发送状态:",
          val: "status",
          selectArr: [
            { label: "全部", id: 0 },
            { label: "已发送", id: 1 },
            { label: "未发送", id: 2 },
            // { label: '黑名单过滤', id: 3 },
            // { label: '10分钟内容重复', id: 4 },
            // { label: '过滤重复发送', id: 5 },
            // { label: '过滤给过中差评', id: 6 },
            // { label: '过滤退过款', id: 7 },
            // { label: '无效号码', id: 8 },
          ],
        },
        {
          name: "手机号:",
          val: "mobile",
          placeholder: "请输入手机号",
        },
      ],
      tableData: [],
      current: 1,
      size: 10,
      total: 0,
      tableOpenAll: false, // 短信内容展开
      talbeLoading: false,
    };
  },
  mounted() {
    this.$refs.form.submitForm("formSearch");
  },
  methods: {
    /**
     * 获取短信记录数据
     */
    getSmsData(params) {
      this.talbeLoading = true;
      params.size = this.size;
      params.current = this.current;
      params.comfrom = "退款审核";
      querySmsList(params).then((res) => {
        this.tableData = res && res.data.records;
        this.total = res && res.data.total;
        this.talbeLoading = false;
      });
    },
    /**
     * 分页变化事件
     */
    handleSizeChange() {},
    handleCurrentChange() {},
  },
};
</script>

<style scoped lang="scss">
.autoRefundSms {
  padding: 24px 0 30px;
  .table {
    box-sizing: border-box;
    padding: 0 28px;
    .state {
      display: flex;
      align-items: center;
      margin: 10px 0;
      span {
        width: 4px;
        height: 4px;
        margin-right: 7px;
        border-radius: 50%;
      }
      .blue {
        background-color: #7f85e9;
      }
      .red {
        background-color: #fe4d45;
      }
    }
    .open,
    .stop {
      color: #fe4d45;
      cursor: pointer;
    }
    .pagination {
      margin-top: 20px;
      text-align: right;
    }
  }
}
</style>